"use strict";
export const emailIsValid = (email) => {
  const simpleEmailRex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return simpleEmailRex.test(String(email).toLowerCase());
};
